import React from 'react'
import {Line} from 'react-chartjs-2'
import PropTypes from 'prop-types';
import {objectWithoutProperties} from '../../../../utils/utils'


//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
};

//================ Default Property Value =====================
const defaultProps={
    
};

const lineChart=(props)=>{

    const _props=props,
            children=_props.children,
            className=_props.className,
            attribute=objectWithoutProperties(props,'children');
        
    return (
        React.createElement(
            Line,
            {className:className,attribute},
            children
        )
    )
}

lineChart.propTypes=propsType;
lineChart.defaultProps=defaultProps;

export default lineChart;